import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ProgramKarsilamaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-program-karsilama',
  templateUrl: 'program-karsilama.html',
})
export class ProgramKarsilamaPage {

  constructor(public navCtrl: NavController,
    public viewCtrl:ViewController,
    public bllOrtak:BllOrtak,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {
   this.GuncellemeAlindi();
  }

  GuncellemeAlindi()
  {
    this.bllOrtak.islemWithoutPost("GuncellemeAlindi", "", false).then(a => {
      var sonuc = <any>a;
     

    }).catch(x=>
      {

      })
  }
  kapat()
  {
    this.viewCtrl.dismiss();

  }
}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/program-karsilama/program-karsilama.ts